<template>
  <div
    ref="messageRef"
    class="ui-ai-conversation-message"
    :class="messageClasses"
  >
    <slot v-if="$slots.message" name="message" />
    <div v-else class="ui-ai-conversation-message__text">
      {{ message.content }}
    </div>
    <div v-if="isHovered" class="ui-ai-conversation-message__actions">
      <UIButtonCopy
        variant="gray"
        fill="light"
        size="xs"
        :text="message.content"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'
import { useElementHover } from '@vueuse/core'

import type { AIMessage } from '@types'

import { UIButtonCopy } from '@ui/buttons'

type Props = {
  message: AIMessage
}

const props = defineProps<Props>()

const messageRef = useTemplateRef('messageRef')

const isHovered = useElementHover(messageRef, {
  delayEnter: 200,
  delayLeave: 100,
})

const messageClasses = computed(() => ({
  [`ui-ai-conversation-message--${props.message.role}`]: true,
}))
</script>

<style>
.ui-ai-conversation-message {
  @apply max-w-full;
  @apply relative;
  @apply flex flex-col items-start gap-2;
  @apply pb-9;

  &--human {
    @apply ml-auto;
  }

  &__text {
    @apply text-base sm:text-sm;
  }

  &--human &__text {
    @apply py-4 px-6;
    @apply bg-body-gray;
    @apply rounded-lg;
  }

  &__actions {
    @apply absolute bottom-1 inset-x-0;
    @apply flex justify-start;

    .ui-button {
      @apply rounded-full;
      @apply text-gray-300 hover:text-gray-400;
      @apply dark:text-gray-500 dark:hover:text-gray-400;
    }
  }
}
</style>
